import $ from 'jquery'
import { Popover, Tooltip } from 'bootstrap'
import { isNonEmptyString, tsInitVue, tsInitVueGrid } from "./js-utils"
import CandidatesGrid from '../js/vue-components/candidates-grid.vue'
import EventsGrid from '../js/vue-components/events-grid.vue'
import TeamsGrid from '../js/vue-components/teams-grid.vue'
import EventEmailTemplateAttachments from '../js/vue-components/event-email-template-attachments.vue'
import EventEmailTemplateTest from '../js/vue-components/event-email-template-test.vue'
import ReimbursementSubmissionsGrid from '../js/vue-components/reimbursement-submissions-grid.vue'
import ParticipantsGrid from '../js/vue-components/participants-grid.vue'
import { initializeAutocompleteField } from './site-utils'

import axios from 'axios'
import Rails from '@rails/ujs'
import type { QueryOptions } from "select2"

document.addEventListener('DOMContentLoaded', () => {

  const eventFormEl = document.querySelector('body.events .events-form, body.event-hosting-offers .event-hosting-offers-form')
  if (eventFormEl instanceof HTMLElement) {
    const eventActivityManagerEl = document.getElementById('event-activity-manager')
    if (eventActivityManagerEl) {
      (async (): Promise<void> => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const EventActivityManager = await import('./vue-components/event-activity-manager.vue')

        window.aManager = tsInitVue(EventActivityManager.default, eventActivityManagerEl, {
          // fixme: load from json field!
          initialDays: window.EventDays as any
        })
      })()
    }

    const startDateEl = document.getElementById("event_start_date_date") ||
      document.getElementById("event_start_date")
    const updateDPViewDate = function (this: any): void {
      if (!startDateEl) {
        return
      }

      const $this = $(this)
      const val = $this.datepicker('getValue')
      if (typeof val === 'string' && val.length === 0) {
        $this.datepicker('setViewDate', $(startDateEl).datepicker('getDate'))
      }
    }
    $('#event_end_date_date').on('show.datepicker', updateDPViewDate)
    $('#event_end_date').on('show.datepicker', updateDPViewDate)
    $('#event_application_deadline').on('show.datepicker', updateDPViewDate)
    $('#event_registration_deadline').on('show.datepicker', updateDPViewDate)
    eventFormEl.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"]').forEach((el) => Tooltip.getOrCreateInstance(el))

    // language levels handling
    const languageLevelsControlEl = eventFormEl.querySelector(':scope div[data-is="EventLanguageLevelsControl"]')
    if (languageLevelsControlEl instanceof HTMLElement) {
      (async (): Promise<void> => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const EventLanguageLevelsControl = await import('./vue-components/event-language-levels-control.vue')

        window.eventLanguageLevelsControl = tsInitVue(EventLanguageLevelsControl.default, languageLevelsControlEl, {
          languageLevelsFieldRef: languageLevelsControlEl.dataset.languageLevelsFieldRef,
          languagesFieldRef: languageLevelsControlEl.dataset.languagesFieldRef,
        })
      })()
    }

    // handle participation type
    const participationTypeControlEl = eventFormEl.querySelector(':scope select[ref="participation-type"]')
    if (participationTypeControlEl instanceof HTMLSelectElement) {
      const updateParticipationTypeMode = () => {
        const v = participationTypeControlEl.value

        const els = eventFormEl.querySelectorAll(':scope [data-participation-type-ids]')
        for (let i = 0; i < els.length; i++) {
          const el = els[i]
          if (el instanceof HTMLElement) {
            const typeIds = el.dataset.participationTypeIds
            if (isNonEmptyString(typeIds)) {
              if (typeIds.split(',').includes(v)) {
                el.classList.remove('d-none')
              } else {
                el.classList.add('d-none')
              }
            }
          }
        }
      }

      participationTypeControlEl.addEventListener('change', () => {
        updateParticipationTypeMode()
      })

      updateParticipationTypeMode()
    }

    // handle dth documents field
    const dthDocumentsEl = eventFormEl.querySelector('div[data-is="event-dth-documents-field"]')
    if (dthDocumentsEl instanceof HTMLElement) {
      (async (): Promise<void> => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const EventDthDocumentsControl = await import('./vue-components/event-dth-documents-field.vue')

        window.eventDthDocumentsControl = tsInitVue(EventDthDocumentsControl.default, dthDocumentsEl, {
          uploadUrl: dthDocumentsEl.dataset.uploadUrl,
          categoryAutocompleteUrl: dthDocumentsEl.dataset.categoryAutocompleteUrl
        })
      })()
    }
  }

  if (document.querySelector('body.events.event-show')) {
    const reloadContent = function () {
      if (window.cGrid) {
        window.cGrid.reload()
      }
      if (window.ocGrid) {
        window.ocGrid.reload()
      }
      if (window.teamsGrid) {
        window.teamsGrid.reload()
      }
      if (window.selectedTeamsGrid) {
        window.selectedTeamsGrid.reload()
      }
      if (window.candidateTeamsGrid) {
        window.candidateTeamsGrid.reload()
      }

      if (window.eventParticipantsGrid) {
        window.eventParticipantsGrid.reload()
      }

      if (window.canceledCandidatesGrid) {
        window.canceledCandidatesGrid.reload()
      }
    }

    const candidatesGridEl = document.querySelector("candidates-grid")
    if (candidatesGridEl instanceof HTMLElement) {
      window.cGrid = tsInitVue(CandidatesGrid, candidatesGridEl, {
        listUrl: candidatesGridEl.dataset.listUrl,
        checkmarks: candidatesGridEl.dataset.checkmarks == "true",
        showEvent: false,
        onContentschanged: function () {
          reloadContent()
        }
      })
    }

    const openCandidatesGridEl = document.querySelector("div[data-is=\"OpenCandidatesGrid\"]")
    if (openCandidatesGridEl instanceof HTMLElement) {
      window.ocGrid = tsInitVue(CandidatesGrid, openCandidatesGridEl, {
        listUrl: openCandidatesGridEl.dataset.listUrl,
        checkmarks: openCandidatesGridEl.dataset.checkmarks == "true",
        showEvent: false,
        onContentschanged: function () {
          reloadContent()
        }
      })
    }

    const teamsGridEl = document.querySelector('#candidates-manager teams-grid#teams-grid')
    if (teamsGridEl instanceof HTMLElement) {
      window.teamsGrid = tsInitVueGrid(TeamsGrid, teamsGridEl, {
        onContentschanged: function () {
          reloadContent()
        }
      })
    }

    const selectedTeamsGridEl = document.querySelector('#candidates-manager teams-grid#selected-teams-grid')
    if (selectedTeamsGridEl instanceof HTMLElement) {
      window.selectedTeamsGrid = tsInitVueGrid(TeamsGrid, selectedTeamsGridEl, {
        onContentschanged: function () {
          reloadContent()
        }
      })
    }

    const candidateTeamsGridEl = document.querySelector('#candidates-manager teams-grid#candidate-teams-grid')
    if (candidateTeamsGridEl instanceof HTMLElement) {
      window.candidateTeamsGrid = tsInitVueGrid(TeamsGrid, candidateTeamsGridEl, {
        onContentschanged: function () {
          reloadContent()
        }
      })
    }

    const participantsGridEl = document.querySelector('#candidates-manager participants-grid#participants-grid')
    if (participantsGridEl instanceof HTMLElement) {
      window.eventParticipantsGrid = tsInitVueGrid(ParticipantsGrid, participantsGridEl, {
        gridTableClass: participantsGridEl.dataset.gridTableClass,
        onContentschanged: function () {
          reloadContent()
        }
      })
    }

    const canceledCandidatesGridEl = document.querySelector('div[data-is="CanceledCandidatesGrid"]')
    if (canceledCandidatesGridEl instanceof HTMLElement) {
      window.canceledCandidatesGrid = tsInitVueGrid(CandidatesGrid, canceledCandidatesGridEl, {
        onContentschanged: function () {
          reloadContent()
        }
      })
    }
  }

  if (document.querySelector('body.events.reimbursement-submissions')) {
    const reimbursementSubmissionsGridEl = document.querySelector('div[data-is="ReimbursementSubmissionsGrid"]')
    if (reimbursementSubmissionsGridEl instanceof HTMLElement) {
      window.reimbursementGrid = tsInitVueGrid(ReimbursementSubmissionsGrid, reimbursementSubmissionsGridEl)
    }
  }


  //
  // Favorites handling
  //
  const editFavoritesEl = document.querySelector('.sidebar .event-favorites .edit-favorites')
  if (editFavoritesEl instanceof HTMLElement) {
    editFavoritesEl.addEventListener('click', function (e) {
      e.preventDefault()
      const favoritesUrl = editFavoritesEl.dataset.url
      if (isNonEmptyString(favoritesUrl)) {
        if (window.favoritesModal == null) {
          (async (): Promise<void> => {
            const favoriteItemsModal = await import('../js/vue-components/favorite-items-modal.vue')

            const favoritesModalEl = document.createElement('div')
            const portalWrapEl = document.getElementById('vue-portal-wrap')
            if (portalWrapEl instanceof HTMLElement) {
              portalWrapEl.append(favoritesModalEl)
              window.favoritesModal = tsInitVue(favoriteItemsModal.default, favoritesModalEl, {
                dataUrl: favoritesUrl,
                modalTitle: 'Manage favorite events',
                loadingMessage: 'Loading events',
                searchPlaceholder: 'Search for event',
                menuElementId: 'favoriteEventsMenu'
              })
            }

            window.favoritesModal.showModal()
          })()
        } else {
          window.favoritesModal.showModal()
        }
      }
    })
  }

  const eventsGridEl = document.querySelector('div[data-is="EventsGrid"]')
  if (eventsGridEl instanceof HTMLElement) {
    window.eventsGrid = tsInitVueGrid(EventsGrid, eventsGridEl, {
      initialFilters: eventsGridEl.dataset.initialFilters,
      addCheckmarks: eventsGridEl.dataset.addCheckmarks == "true"
    })
  }
})

$(function () {
  if ($('body.events.events-list').length) {
    let ajaxUrl = null as string | null

    const yearField = document.querySelector('select[ref="events-year"]')
    const searchFieldEl = document.querySelector('select[ref="events-search"]')
    if (searchFieldEl instanceof HTMLSelectElement) {
      const searchField = initializeAutocompleteField(searchFieldEl, undefined, undefined, function (options) {
        if (options?.ajax && typeof options?.ajax?.url === 'function') {
          ajaxUrl = options.ajax.url({})

          // eslint-disable-next-line no-unused-vars
          options.ajax.url = function (_params: QueryOptions): string {
            return ajaxUrl || ''
          }
        }
        return options
      })

      if (searchField) {
        if (yearField instanceof HTMLSelectElement) {
          const applySelectedYear = function () {
            if (yearField.selectedIndex >= 0) {
              const item = yearField.item(yearField.selectedIndex)
              if (item instanceof HTMLOptionElement) {
                ajaxUrl = item.dataset.autocompleteUrl || null

                // In Vue 3 root component props can not be reactive, therefore created a method to overrideset listUrl
                window.eventsGrid.setListUrl(item.dataset.listUrl)
                window.eventsGrid.$nextTick(function () {
                  window.eventsGrid.reload()
                })
              }
            }
          }

          $(yearField).on('change', function () {
            applySelectedYear()
          })
          applySelectedYear()
        }

        $(searchField).on('select2:select', function (e) {
          if (e.params.data.id) {
            const [filterType, filterValue] = e.params.data.id.split(':', 2)
            if (filterType === 'filter') {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              window.eventsGrid.setFilterParams({ filter_text: filterValue })
              history.pushState({ filterText: filterValue, q: e.params.data }, 'Event search', `?filter_text=${filterValue}`)
            } else if (filterType === 'e') {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              window.eventsGrid.setFilterParams({ filter_id: filterValue })
              history.pushState({ filterId: filterValue, q: e.params.data }, 'Event search', `?filter_id=${filterValue}`)
            }
          }
        })

        $(searchField).on('select2:unselect', function () {
          // reset filter
          window.eventsGrid.setFilterParams({})
          history.pushState({ filterText: null }, 'Event search', `?`)
        })
      }

      window.onpopstate = function (event: any) {
        if (searchField instanceof HTMLSelectElement) {
          const state = event.state
          let eventsLoaded = false
          if (typeof state === 'object' && state !== null) {
            if (state.q != null) {
              const newOption = new Option(state.q.text, state.q.id, true, true)
              $(searchField).append(newOption).trigger('change')
              if (isNonEmptyString(state.filterText)) {
                eventsLoaded = true
                // eslint-disable-next-line @typescript-eslint/naming-convention
                window.eventsGrid.setFilterParams({ filter_text: state.filterText })
              } else if (state.filterId != null) {
                eventsLoaded = true
                // eslint-disable-next-line @typescript-eslint/naming-convention
                window.eventsGrid.setFilterParams({ filter_id: state.filterId })
              }
            }
          }

          if (!eventsLoaded) {
            // no push state found, perform initial query
            $(searchField).val('').trigger('change')
            window.eventsGrid.setFilterParams({})
          }
        }
      }
    }
  }

  if ($('body.event-email-templates').length) {
    const templateAttachmentsEl = document.querySelector('div[data-is="EventEmailTemplateAttachments"]')
    if (templateAttachmentsEl instanceof HTMLElement) {
      const templateAttachmentsProps = {
        fieldName: templateAttachmentsEl.dataset.fieldName || '',
        initialFiles: window.templateAttachmentFiles,
        uploadUrl: templateAttachmentsEl.dataset.uploadUrl,
      }
      window.eventEmailTemplateAttachments = tsInitVue(EventEmailTemplateAttachments, templateAttachmentsEl, templateAttachmentsProps)
    }

    const templateTestEl = document.querySelector('div[data-is="EventEmailTemplateTest"]')
    if (templateTestEl instanceof HTMLElement) {
      window.eventEmailTemplateTest = tsInitVue(EventEmailTemplateTest, templateTestEl, {
        defaultRecipient: templateTestEl.dataset.defaultRecipient,
        sendUrl: templateTestEl.dataset.sendUrl,
        emailTemplates: window.emailTemplates
      })
    }


    const copyDefaultTemplate = function(actionName: string, copyUrl: string): void {
      let warningMessage = ''
      if (actionName === 'copy-subject-and-body') {
        warningMessage = 'Warning! This will replace subject and body of your custom message with generic message. Are you sure?'
      } else if (actionName === 'copy-subject') {
        warningMessage = 'Warning! This will replace subject of your custom message with generic message. Are you sure?'
      } else if (actionName === 'copy-body') {
        warningMessage = 'Warning! This will replace body of your custom message with generic message. Are you sure?'
      } else {
        return
      }

      if (confirm(warningMessage)) {
        axios.post(copyUrl, {}, {
          headers: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'X-Requested-With': 'XMLHttpRequest',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'X-CSRF-Token': Rails.csrfToken()
          }
        })
          .then((response) => {
            if (actionName === 'copy-subject-and-body') {
              $('input[name="event_email_template[subject]"]').val(response.data.subject)
              window.fWYSIWYG.get('event_email_template_body_html').setContent(response.data.body)
            } else if (actionName === 'copy-subject') {
              $('input[name="event_email_template[subject]"]').val(response.data.subject)
            } else if (actionName === 'copy-body') {
              window.fWYSIWYG.get('event_email_template_body_html').setContent(response.data.body)
            }
          })
          .catch((error) => {
            alert(`An error occured: ${error.message}`)
          })

      }
    }

    $('[ref="restore-generic-message"] .dropdown-item[data-action]').click(function (e) {
      e.preventDefault()
      const actionName = $(this).data('action')
      const copyUrl = $(this).closest('[ref="restore-generic-message"]').data('url')
      copyDefaultTemplate(actionName, copyUrl)
    })
  }
})

$(function () {
  if ($('body.event-email-templates').length) {
    document.querySelectorAll<HTMLElement>('[data-bs-toggle="popover"]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
      })
      Popover.getOrCreateInstance(el)
    })
  }
})
